import { Icon, type IconProps } from './Icon';

/** Confirmado, selecionado, acertou. Substitui o `✓`. */
export function CheckIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M20 6 9 17l-5-5" />
    </Icon>
  );
}
